
  import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCwUQBFBJIPkzCw5RsJPNzbTseauZHJu7U",
    authDomain: "secret-mission-59aab.firebaseapp.com",
    projectId: "secret-mission-59aab",
    storageBucket: "secret-mission-59aab.appspot.com",
    messagingSenderId: "770624773945",
    appId: "1:770624773945:web:24151118fc09290f4512e8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };